const SELECTOR_INPUT = 'input[type="checkbox"]';

export default function loadFilterForm($form: HTMLFormElement) {
	const params = new URLSearchParams(document.location.search);

	const $inputs = $form.querySelectorAll<HTMLInputElement>(SELECTOR_INPUT);

	$inputs.forEach(($input) => {
		$input.addEventListener('change', () => {
			if ($input.checked) {
				params.append($input.name, $input.value);
			} else {
				const values = params.getAll($input.name).filter((value) => value !== $input.value);

				params.delete($input.name);

				values.forEach((value) => {
					params.append($input.name, value);
				});

				if (!params.get($input.name)) {
					params.delete($input.name);
				}
			}

			// Reset `page` param on filter change
			if (params.has('page')) {
				params.delete('page');
			}

			location.href = `?${params}`;
		});
	});
}
